<!--
 * @Author: 仙道
 * @Date: 2022-04-23 17:56:48
 * @LastEditTime: 2022-08-24 16:48:30
 * @email: hao.li08@weimob.com
 * @Description:
 * @FilePath: /iplus-iwt-fe/src/views/equipment/account/modules/text/BaseInfo.vue
-->
<template>
  <div class="flex">
    <div class="w-150px flex justify-center items-start">
      <j-image-upload :disabled="true" bizPath="scott/pic" v-if="devicePicture" v-model="devicePicture"></j-image-upload>
    </div>
    <detail-list class="flex-1">
      <detail-list-item :key="key" :term="item.name" class="info-item" v-for="(item,key) in accountItemTab">
        <div class="w-100px h-100px qcode relative" v-if="item.type&&item.type==='img'">
          <!-- <img :src="item.v" class="w-80px h-80px" /> -->
          <j-image-upload :disabled="true" bizPath="scott/pic" class="w-80px h-80px" v-if="item.v" v-model="item.v"></j-image-upload>
        </div>
        <span v-else-if="item.type&&item.type==='emnu'">{{ item.emnu[item.v] }}</span>
        <span v-else>{{ item.v||'--' }}</span>
      </detail-list-item>
    </detail-list>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import DetailList from '@/components/tools/DetailList'
  import { cloneObject } from '@/utils/util'
  import { getAction } from '@/api/manage'
  const DetailListItem = DetailList.Item

  export default {
    name: 'BaseInfo',
    components: {
      DetailList,
      DetailListItem
    },
    props: {
      operationType: {
        type: String,
        default: ''
      },
      propsData: {
        type: Object,
        default: () => { }
      },
      deviceId: {
        type: String,
        default: ''
      }
    },
    // 定义属性
    data () {
      return {
        devicePicture: '',
        accountItemTab: [
          {
            name: '设备名称',
            k: 'devName',
            v: ''
          },
          {
            name: '表号',
            k: 'devTag',
            v: ''
          },
          {
            name: '设备类型',
            k: 'typeName',
            v: ''
          },
          {
            name: '设备状态',
            k: 'serviceStatus',
            type: 'emnu',
            emnu: {
              1: '运行中',
              2: '停运'
            }
          },
          //   {
          //     name: '供水流域',
          //     k: 'areaName',
          //     v: ''
          //   },
          {
            name: '供水流域',
            k: 'processName',
            v: ''
          },
          {
            name: '重要性',
            k: 'importance',
            v: '',
            type: 'emnu',
            emnu: {
              1: '重要',
              2: '不重要'
            }
          },
          {
            name: '负责人',
            k: 'multiUser',
            v: ''
          },

          {
            name: '上级设备',
            k: 'parent_id',
            v: ''
          }, {
            name: '生产厂家',
            k: 'manuName',
            v: ''
          }, {
            name: '设备型号',
            k: 'modelName',
            v: ''
          }, {
            name: '出厂日期',
            k: 'factoryDate',
            v: ''
          }, {
            name: '出厂编号',
            k: 'factoryNumber',
            v: ''
          }, {
            name: '使用寿命',
            k: 'runningLife',
            v: ''
          }, {
            name: '剩余寿命',
            k: 'accountc',
            v: ''
          }, {
            name: '下次维保',
            k: 'accountNext',
            v: ''
          }, {
            name: '二维码',
            k: 'qrcode',
            v: '',
            type: 'img'
          }
        ],
        url: {
          queryById: '/device/devList/queryDetailById'
        }
      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters([''])
    },
    // 监控data中的数据变化
    watch: {},
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {
      const accountItemTab = cloneObject(this.accountItemTab)
      const propsData = cloneObject(this.propsData)

      const itemObject = accountItemTab.map(item => {
        if (Object.prototype.hasOwnProperty.call(propsData, item.k)) {
          item.v = propsData[item.k]
        }
        console.info(JSON.stringify(item))
        return item
      })

      this.accountItemTab = itemObject
      this.init()
    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      init () {
        getAction(this.url.queryById, { id: this.deviceId }).then(res => {
          const deviceData = res.result
          this.accountItemTab.reduce((acc, cur) => {
            cur.v = deviceData[cur.k]
            acc.push(cur)
            return acc
          }, [])
          this.devicePicture = deviceData.pictureObjId
        })
      }
    }
  }
</script>

<style lang='less'>
  .info-item .term {
    vertical-align: top;
  }
</style>
